import { render, staticRenderFns } from "./Persona_agregar.vue?vue&type=template&id=05c74e08&scoped=true"
import script from "./Persona_agregar.vue?vue&type=script&lang=js"
export * from "./Persona_agregar.vue?vue&type=script&lang=js"
import style0 from "./Persona_agregar.vue?vue&type=style&index=0&id=05c74e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c74e08",
  null
  
)

export default component.exports